
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/[slug2]",
      function () {
        return require("private-next-pages/[slug]/[slug2].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/[slug2]"])
      });
    }
  